import { defineMessages } from 'react-intl';

export const messages: {
	pulseTileLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	pulseTileLabel: {
		id: 'rovo-growth-pulse.pulse-tile.label.V3',
		defaultMessage: 'Rovo Insights',
		description:
			'Accessible label for the Rovo Insights tile that displays the generative indicator icon. "Rovo" is an Atlassian product name and should not be translated.',
	},
});
